import { Box } from '@mui/material';
import { ErrorAlertComponent } from 'lib/ErrorAlert';
import { Outlet } from 'react-router';
import { GlobalMenuBar } from '@/components/GlobalMenuBar';
import { ProjectsProvider } from '@/providers/ProjectsProvider';

export const AppShell = () => {
  const pages = [
    { label: 'サマリー', to: '/' },
    { label: 'グラフ', to: '/graph' },
  ];

  return (
    <Box sx={{ display: 'flex' }} justifyContent={'center'}>
      <ErrorAlertComponent float />
      <GlobalMenuBar pages={pages} />
      <ProjectsProvider>
        <Outlet />
      </ProjectsProvider>
    </Box>
  );
};
